
import About from "./pages/About/About";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import GoogleMeSis from "./pages/Resources/GoogleMeSis"
import EliteVisible from "./pages/Services/EliteVisible";
import VisibilityAudit from "./pages/Services/VisibilityAudit"
import LocalSEO from "./pages/Services/LocalSEO";
import Contact from "./pages/Contact";
import Services from "./pages/Services/Services";
import PlayBook from "./pages/Resources/PlayBook";
import FreeReviewLanding from "./pages/Services/FreeReviewLanding";
import CaseStudies from "./pages/Resources/CaseStudies";
import ReviewConfirmation from "./pages/ReviewConfirmation";
import WebDesign from "./pages/Services/WebDesign"
import OurDifference from "./pages/About/OurDifference";
import Careers from "./pages/About/Careers";
import Blog from "./pages/Resources/Blog/Blog"
import AllPlaybooks from "./pages/Resources/AllPlaybooks";
import ToolsWeUse from "./pages/Resources/ToolsWeUse";
import Testimonials from "./pages/About/Testimonials";
import StartAProject from "./pages/Services/StartAProject";
import SeoPage from "./pages/Services/SeoPage";
import ShephedLaw from "./pages/Resources/CaseStudies/ShephedLaw";
import WireframeKits from "./pages/Services/WireframeKits";
import WebsiteRefresh from "./pages/Services/WebsiteRefresh";
import AccessibilityAudits from "./pages/Services/AccessibilityAudits";
import AuthorityAmplifier from "./pages/Services/AuthorityAmplifier"
import AuthorityLaunchpad from "./pages/Services/AuthorityLaunchpad"
import StrategicGrowthAccelerator from "./pages/Services/StrategicGrowthAccelerator"
import Blog1Essentials from "./pages/Resources/Blog/Blog1Essentials";
import Blog2Signs from "./pages/Resources/Blog/Blog2Signs";
import BlogAuthorityLaunchpad from "./pages/Resources/Blog/BlogAuthorityLaunchpad";
import BlogAuthorityAmplifier from "./pages/Resources/Blog/BlogAuthorityAmplifier";
import BlogStrategicGrowth from "./pages/Resources/Blog/BlogStrategicGrowth";
import Lubbock from "./pages/SEO Pages/Lubbock";
import SanAntonio from "./pages/SEO Pages/SanAntonio";
import Houston from "./pages/SEO Pages/Houston";
import FortWorth from "./pages/SEO Pages/FortWorth";
import Dallas from "./pages/SEO Pages/Dallas";
import Austin from "./pages/SEO Pages/Austin";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/visibilityaudit" element={<VisibilityAudit />} />
        <Route path="/elitevisible" element={<EliteVisible />} />
        <Route path="/googlemesis" element={<GoogleMeSis />} />
        <Route path="/localseo" element={<LocalSEO />}/>
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/services" element={<Services />} />
        <Route path="/playbook" element={<PlayBook />} /> 
        <Route path="/freereviewlanding" element={<FreeReviewLanding />} /> 
        <Route path="/casestudies" element={<CaseStudies />} /> ReviewConfirmation
        <Route path="/reviewconfirmation" element={<ReviewConfirmation />} />
        <Route path="/webdesign" element={<WebDesign />} />
        <Route path="/ourdifference" element={<OurDifference />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/allplaybooks" element={<AllPlaybooks />} />
        <Route path="/toolsweuse" element={<ToolsWeUse />} />
        <Route path="/testimonials" element={<Testimonials />} /> 
        <Route path="/startaproject" element={<StartAProject />} /> 
        <Route path="/seopage" element={<SeoPage />} /> 
        <Route path="/shephedlaw" element={<ShephedLaw />} /> 
        <Route path="/wireframekits" element={<WireframeKits />} />
        <Route path="/websiterefresh" element={<WebsiteRefresh />} /> 
        <Route path="/accessibilityaudits" element={<AccessibilityAudits />} />
        <Route path="/authorityamplifier" element={<AuthorityAmplifier />} />
        <Route path="/authoritylaunchpad" element={<AuthorityLaunchpad />} />
        <Route path="/strategicgrowthaccelerator" element={<StrategicGrowthAccelerator />} />
        <Route path="/essentialswebsitepages" element={<Blog1Essentials />} /> 
        <Route path="/websiteredesignsigns" element={<Blog2Signs />} />
        <Route path="/blogauthoritylaunchpad" element={<BlogAuthorityLaunchpad />} />
        <Route path="/blogauthorityamplifier" element={<BlogAuthorityAmplifier />} />
        <Route path="/blogstrategicgrowth" element={<BlogStrategicGrowth />} />
        <Route path="/web-design-seo-women-entrepreneurs-austin" element={<Austin />} />
        <Route path="/dallas-female-founder-website-design" element={<Dallas />} />
        <Route path="/web-design-seo-women-entrepreneurs-fortworth" element={<FortWorth />} />
        <Route path="/houston-female-founder-website-design" element={<Houston />} />
        <Route path="/web-design-seo-women-entrepreneurs-sanantonio" element={<SanAntonio />} />
        <Route path="/lubbock-female-founder-website-design" element={<Lubbock />} />
        </Routes>
        </div>
  )
}

export default App;
